<template>
  <div class="template-pie-wrapper">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs';

export default {
  extends: Doughnut,
  name: 'ApiErrorsTemplatePieChart',
  props: {
    apiErrors: {
      type: Array,
      required: true,
    },
  },
  methods: {
    updateChart() {
      const total = this.apiErrors.length;
      const sim = this.apiErrors.filter(e => e.is_template === 'sim').length;
      const nao = total - sim;

      this.renderChart(
        {
          labels: ['sim', 'não'],
          datasets: [
            {
              data: [sim, nao],
              backgroundColor: ['#42a5f5', '#f39c12'],
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: 'right',
            labels: {
              fontSize: 12,
            },
          },
        }
      );
    },
  },
  watch: {
    apiErrors: {
      immediate: true,
      handler() {
        if (this.apiErrors.length > 0) this.updateChart();
      },
    },
  },
  mounted() {
    this.updateChart();
  },
};
</script>


<style scoped>
.template-pie-wrapper {
  width: 250px;
  height: 250px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>
